import { UPDATE_COMMENT_FAILURE } from '../../actions/update-comment';
import { CREATE_COMMENT_FAILURE } from '../../actions/create-comment';
import { CREATE_POST_FAILURE } from '../../actions/create-post';
import { UPDATE_POST_FAILURE } from '../../actions/update-post';
import { POST_INVALID, COMMENT_INVALID } from './message-types';

export default {
  [CREATE_POST_FAILURE]: action => {
    if (action.meta.status === 412) {
      return POST_INVALID;
    }
  },
  [UPDATE_POST_FAILURE]: action => {
    if (action.meta.status === 412) {
      return POST_INVALID;
    }
  },
  [CREATE_COMMENT_FAILURE]: action => {
    if (action.meta.status === 412) {
      return COMMENT_INVALID;
    }
  },
  [UPDATE_COMMENT_FAILURE]: action => {
    if (action.meta.status === 412) {
      return COMMENT_INVALID;
    }
  },
};
